import { ValidatorTypes } from "../../../util/validators";

export const supplierInputFields = {
    vendorType: {
        name: "vendorType",
        label: "Select Vendor Type",
        items: [],
        type: "select",
        touched: false,
        error: false,
        valid: true,
        value: "Supplier",
        dataCy: "vendor-type-select",
        validation: [ValidatorTypes.REQUIRED],
    },
    businessName: {
        name: "businessName",
        label: "Business Name",
        type: "text",
        touched: false,
        error: false,
        valid: true,
        value: "",
        dataCy: "business-name-input",
        validation: [ValidatorTypes.REQUIRED],
    },
    abn: {
        name: "abn",
        label: "11 digit ABN",
        type: "text",
        touched: false,
        error: false,
        valid: true,
        value: "",
        dataCy: "abn-input",
        validation: [ValidatorTypes.ABN],
    },
    street_address: {
        name: "street_address",
        label: "Street Address",
        type: "address",
        touched: false,
        error: false,
        valid: true,
        value: "",
        dataCy: "street-address-input",
        validation: [ValidatorTypes.OPTIONAL],
    },
    suburb: {
        name: "suburb",
        label: "Suburb",
        type: "address",
        touched: false,
        error: false,
        valid: true,
        value: "",
        dataCy: "suburb-input",
        validation: [ValidatorTypes.OPTIONAL],
    },
    state: {
        name: "state",
        label: "State",
        type: "address",
        touched: false,
        error: false,
        valid: true,
        value: "",
        dataCy: "state",
        validation: [ValidatorTypes.OPTIONAL],
    },
    postcode: {
        name: "postcode",
        label: "Postcode",
        type: "text",
        touched: false,
        error: false,
        valid: true,
        value: "",
        dataCy: "postcode-input",
        validation: [ValidatorTypes.OPTIONAL],
    },
    country: {
        name: "country",
        label: "Country",
        type: "address",
        touched: false,
        error: false,
        valid: true,
        value: "",
        dataCy: "country",
        validation: [ValidatorTypes.OPTIONAL],
    },
    phoneNumber: {
        name: "phoneNumber",
        label: "Phone Number",
        type: "text",
        touched: false,
        error: false,
        valid: true,
        value: "",
        dataCy: "phone-number-input",
        validation: [ValidatorTypes.REQUIRED, ValidatorTypes.PHONE_NUMBER],
    },
    email: {
        name: "email",
        label: "Email",
        type: "email",
        touched: false,
        error: false,
        valid: true,
        value: "",
        dataCy: "email-input",
        validation: [ValidatorTypes.REQUIRED, ValidatorTypes.EMAIL],
    },
    website: {
        name: "website",
        label: "Website",
        type: "text",
        touched: false,
        error: false,
        valid: true,
        value: "",
        dataCy: "website-input",
        validation: [ValidatorTypes.OPTIONAL, ValidatorTypes.WEBSITE],
    },
    paymentTerms: {
        name: "paymentTerms",
        label: "Payment Terms (Days)",
        type: "number",
        min: 0,
        touched: false,
        error: false,
        valid: true,
        value: "",
        dataCy: "payment-terms-input",
        validation: [ValidatorTypes.REQUIRED, ValidatorTypes.PAYMENT_TERMS],
    }
}
